import moment from "moment";

function dateTimeID(value) {
    return moment(value).format('DD MMM YYYY | HH:mm') // 24  month 2020 | 21:00
}
function convertDateTime(value) {
    const day = {Monday : 'Senin',Tuesday : 'Selasa',Wednesday : 'Rabu',Thursday: 'Kamis',Friday : 'Jumat',Saturday: 'Sabtu',Sunday : 'Minggu'}
    const temp = moment(value).format('dddd, DD-MM-YYYY | HH:mm') // Saturday, 25-04-2020 | 21:00
    const split = temp.split(",")
    const selectedDay = day[split[0]]
    return selectedDay+ ',' + split[1] // Sabtu, 25-04-2020 | 21:00
}
function convertDate(value) {
    const day = {Monday : 'Senin',Tuesday : 'Selasa',Wednesday : 'Rabu',Thursday: 'Kamis',Friday : 'Jumat',Saturday: 'Sabtu',Sunday : 'Minggu'}
    const temp = moment(value).format('dddd, DD-MM-YYYY') // Saturday, 25-04-2020
    const split = temp.split(",")
    const selectedDay = day[split[0]]
    return selectedDay+ ',' + split[1] // Sabtu, 25-04-2020
}
function diffDate(begin,end){
    const dateBegin = moment(begin, 'DD-MM-YYYY'); 
    const dateEnd = moment(end, 'DD-MM-YYYY');
    return dateEnd.diff(dateBegin, 'days')
}
function formatDate(value){
    return moment(value).format('YYYY-MM-DD')
}
function formatDateTime(value){
    return moment(value).format('YYYY-MM-DD HH:mm')
}
function countAge(value){
    const birthyear = moment(value, 'YYYY-MM-DD'); 
    return moment().diff(birthyear, 'years');
}
function countAgeWithMonth(begin,end = new Date()){
    const start_date = moment(begin);
    const end_date = moment(end);
    const years = end_date.diff(start_date, 'year');
    start_date.add(years, 'years');
    const months = end_date.diff(start_date, 'months');

    const resultMonth = months == 0 ? "" : `${months} Bulan`
    const resultYear = years == 0 ? "" : `${years} Tahun `
    return resultYear + resultMonth ; 
}

// crate function to return last minute, last hour, last day, last week, last month, last year from created_at  
function timeSince(date) {
    let seconds = Math.floor((new Date() - new Date(date)) / 1000);
    let interval = seconds / 31536000;
    if (interval > 1) {
      return Math.floor(interval) + " Tahun yang lalu";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " Bulan yang lalu";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " Hari yang lalu";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " Jam yang lalu";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " Menit yang lalu";
    }
    return Math.floor(seconds) + " Detik yang lalu";
}

function commonDateTimeFormat(value){
    return moment(value).format('DD MMM YYYY')
}
function customFormat(value, format = 'DD MMM YYYY'){
    return moment(value).format(format)
}
function dashboardDateTime(value) {
    return moment(value).format('dddd, DD MMM YYYY'); // Saturday, 25-04-2020
}
function convertDatetoStringDate(value){
    return moment(value).format('ddd'); //sunday
}
function yearOnly(value){
    return moment(value).format('YYYY'); //2020
}
function monthOnly(value){
    return moment(value).format('MMM'); //Sept
}
function dateOnly(value){
    return moment(value).format('DD'); //26
}
function timeFormat(value){
    const temp = value.split(':')
    return temp[0] + ":" + temp[1]
}
function tomorrow(){
    const today = moment();
    const tomorrow = moment(today).add(1, 'days');
    return new Date(formatDate(tomorrow))
}
function addDate(date,dayAdd){
    const resutlDate = moment(date).add(dayAdd, 'days');
    return new Date(formatDate(resutlDate))
}
function compareDate(begin,end){
    const today = moment().format('YYYY-MM-DD')
    const start_date =  begin
    const end_date = end
    if(today >= start_date && today <= end_date){
        return {message: 'Aktif', class: 'ongoing'}
    }else if(today > start_date){
        return {message: 'Telah Berakhir', class: 'finish'}
    }
    return {message: 'Belum Dimulai', class: 'notyet'}
}

const diffDateTime = (begin,end) =>{
    const dateBegin = moment(begin); 
    const dateEnd = moment(end);
    return dateEnd.diff(dateBegin, 'minutes')
}

export {
    convertDateTime,
    convertDate,
    dashboardDateTime,
    convertDatetoStringDate,
    monthOnly,
    dateOnly,
    timeFormat,
    diffDate,
    formatDate,
    tomorrow,
    commonDateTimeFormat,
    addDate,
    yearOnly,
    compareDate,
    countAge,
    countAgeWithMonth,
    dateTimeID,
    formatDateTime,
    customFormat,
    diffDateTime,
    timeSince
}